module.exports = __webpack_public_path__ + "img/navoj.deae7b49.jpg";